import { FC } from 'react';
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from '@mui/material';
import { useTimepointDialogController } from './useTimepointDialogController';

interface Props {
  open: boolean;
  onClose: () => void;
  onSaved: () => void;
}

/** Adds a shared timepoint label. Timepoints can't be renamed or removed, since results are grouped by them. */
export const TimepointDialog: FC<Props> = ({ open, onClose, onSaved }) => {
  const timepointDialog = useTimepointDialogController(open, onSaved);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>New Timepoint</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          Schedules share timepoints, so results for the same timepoint can be compared across schedules. Reuse BASELINE
          or END where they fit.
        </DialogContentText>
        {timepointDialog.error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {timepointDialog.error}
          </Alert>
        )}
        <TextField
          label="Name"
          value={timepointDialog.name}
          onChange={(e) => timepointDialog.handleNameChange(e.target.value)}
          fullWidth
          sx={{ mb: 2 }}
          helperText="e.g. Week 5"
        />
        <TextField
          label="Code"
          value={timepointDialog.code}
          onChange={(e) => timepointDialog.handleCodeChange(e.target.value)}
          fullWidth
          helperText="e.g. WEEK_5"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={timepointDialog.saving}>
          Cancel
        </Button>
        <Button variant="contained" onClick={timepointDialog.handleSave} disabled={!timepointDialog.canSave}>
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
};
